import { WIND_RAMP_KMH, createWindSampler, windSpeedDir } from "@divespots/contracts";
import type { WindField } from "@divespots/contracts";
import { msToKmh } from "./ramp.ts";

export const COMPASS = ["n", "ne", "e", "se", "s", "sw", "w", "nw"] as const;
export type Compass = (typeof COMPASS)[number];

/** The 8-point compass sector a FROM-direction (degrees) falls in. */
export const compassOf = (dirFromDeg: number): Compass =>
  COMPASS[Math.round((((dirFromDeg % 360) + 360) % 360) / 45) % 8]!;

export interface WindReading {
  kmh: number;
  from: Compass;
  /** Below the first ramp step's tenth: reported as calm, never with a direction. */
  calm: boolean;
}

/** Wind at a point and time, or null where the model has no data (never "calm"). */
export function readWind(
  field: Pick<WindField, "grid" | "times" | "u" | "v">,
  lat: number,
  lon: number,
  tMs: number,
): WindReading | null {
  const w = createWindSampler(field)(lon, lat, tMs);
  if (!w) return null;
  const { speedMs, dirFromDeg } = windSpeedDir(w.u, w.v);
  const kmh = msToKmh(speedMs);
  return { kmh: Math.round(kmh), from: compassOf(dirFromDeg), calm: kmh < 1 };
}

/** Speed band index 0..3 per `WIND_RAMP_KMH` (for tests and styling hooks). */
export const bandOf = (kmh: number): number => WIND_RAMP_KMH.filter((l) => kmh >= l).length;
